import urlTool from '@/tools/url';
import fetchJQueryAdapter from '@/tools/fetchJQueryAdapter';

/**
 * @memberof module:ajaxAPI/compare
 * @alias get
 *
 * @description
 * Получение списка сравнения
 *
 * @return {$.ajax}
 *
 * @example
 * ajaxAPI.compare.get()
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) });
 */

export default function(id) {
  const lang = urlTool.getKeyValue('lang') || '';
  const request_url = `${window.location.origin}/front_api/compares.json`;

  let path = new URL(request_url);

  if (lang) {
    path.searchParams.set('lang', lang);
  }

  return fetchJQueryAdapter(path);
};
